import { Component, Vue, Watch } from 'vue-property-decorator';
import { Footer as TheFooter } from '@coreui/vue';
import { AppStoreModule } from '@/store';
import AppStore from '@/store/modules/AppStoreModule';
import { AppSpinnerModal } from '@/components/app';
import { TelstraUIVueSvg, TelstraUIVueSideNav, TelstraUIVueHeader, TelstraUIVueDialog } from '@/external/telstra-ui-vue/components';

interface SpinnerModalRef {
  showModal: () => void;
  hideModal: () => void;
}

@Component({
  components: {
    TelstraUIVueSideNav,
    TelstraUIVueHeader,
    TheFooter,
    AppSpinnerModal,
    TelstraUIVueSvg,
    TelstraUIVueDialog,
  },
})
export default class DefaultContainer extends Vue {
  app$: AppStore = AppStoreModule;

  get name() {
    return this.$route.name;
  }

  get isHome() {
    return this.name === 'Registrations';
  }

  get applicationStatus() {
    return this.app$.applicationStatus;
  }

  get httpErrorMessage() {
    return this.app$.httpError;
  }

  get spinnerModal(): SpinnerModalRef {
    return this.$refs.spinnerModal as unknown as SpinnerModalRef;
  }

  get httpErrorModal(): TelstraUIVueDialog {
    return this.$refs.httpErrorModal as TelstraUIVueDialog;
  }

  get isLoading(): boolean {
    return this.app$.isLoading;
  }

  @Watch('isLoading')
  handleSpinnerModal() {
    if (this.isLoading) {
      this.spinnerModal.showModal();
    } else {
      this.spinnerModal.hideModal();
    }
  }

  @Watch('httpErrorMessage')
  displayErrorDialog() {
    if (this.httpErrorMessage) {
      this.httpErrorModal.show();
    }
  }

}
